import { alpha } from "@mui/material/styles";
import { Box, Button, Container, Paper, Stack, Typography } from "@mui/material";

const backgroundColor = "#f9f9f9";
const textColor = "#1a1a1a";
const secondaryTextColor = "#666666";
const fontFamilyPrimary = "'Inter', sans-serif";

export function StoreNotFoundPage() {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 2,
                py: 4,
                position: "relative",
                overflow: "hidden",
                backgroundColor,
                "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundImage:
                        `linear-gradient(${alpha(textColor, 0.04)} 1px, transparent 1px), ` +
                        `linear-gradient(90deg, ${alpha(textColor, 0.04)} 1px, transparent 1px)`,
                    backgroundSize: "60px 60px",
                    pointerEvents: "none",
                },
            }}
        >
            <Container maxWidth="sm">
                <Paper
                    elevation={0}
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        p: { xs: 4, sm: 5 },
                        borderRadius: 4,
                        textAlign: "center",
                        border: `1px solid ${alpha(textColor, 0.12)}`,
                        backgroundColor: alpha(textColor, 0.05),
                        backdropFilter: "blur(12px)",
                        boxShadow: `0 24px 80px ${alpha(textColor, 0.1)}`,
                        color: textColor,
                        "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "1px",
                            background: `linear-gradient(90deg, transparent, ${alpha(textColor, 0.5)}, transparent)`,
                        },
                    }}
                >
                    <Stack spacing={3} alignItems="center">
                        <Box
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 1,
                                px: 2,
                                py: 0.85,
                                borderRadius: "999px",
                                backgroundColor: alpha(textColor, 0.07),
                                border: `1px solid ${alpha(textColor, 0.18)}`,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    backgroundColor: textColor,
                                    opacity: 0.5,
                                }}
                            />
                            <Typography
                                sx={{
                                    fontFamily: fontFamilyPrimary,
                                    fontSize: "0.75rem",
                                    fontWeight: 700,
                                    letterSpacing: "0.06em",
                                    textTransform: "uppercase",
                                    color: alpha(textColor, 0.65),
                                }}
                            >
                                Tienda no encontrada
                            </Typography>
                        </Box>

                        <Typography
                            sx={{
                                fontFamily: fontFamilyPrimary,
                                fontSize: { xs: "28px", sm: "36px" },
                                fontWeight: 800,
                                lineHeight: 1.2,
                                letterSpacing: "-0.02em",
                                color: textColor,
                            }}
                        >
                            Esta tienda no existe o ya no está disponible
                        </Typography>

                        <Typography
                            sx={{
                                fontFamily: fontFamilyPrimary,
                                fontSize: "16px",
                                color: secondaryTextColor,
                                lineHeight: 1.7,
                                maxWidth: 420,
                            }}
                        >
                            Verificá que la dirección sea correcta o contactá a quien te compartió
                            este enlace.
                        </Typography>

                        <Button
                            component="a"
                            href="https://tindi.com.ar"
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="contained"
                            sx={{
                                backgroundColor: textColor,
                                color: backgroundColor,
                                fontFamily: fontFamilyPrimary,
                                fontWeight: 700,
                                fontSize: { xs: "0.95rem", md: "1rem" },
                                px: { xs: 3, md: 4 },
                                py: { xs: 1.5, md: 1.75 },
                                borderRadius: "10px",
                                textTransform: "none",
                                boxShadow: `0 8px 24px ${alpha(textColor, 0.2)}`,
                                "&:hover": {
                                    backgroundColor: textColor,
                                    opacity: 0.88,
                                    transform: "translateY(-1px)",
                                    boxShadow: `0 12px 32px ${alpha(textColor, 0.28)}`,
                                },
                                transition: "all 0.2s ease",
                            }}
                        >
                            Conocer Tindi
                        </Button>
                    </Stack>
                </Paper>
            </Container>
        </Box>
    );
}
